import React from "react";
import styles from "../businessConfig/BusinessConfig.module.scss";
import { Divider, TextareaAutosize } from "@material-ui/core";
import { InputLabel, TextField } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "../../formUI/Select";
import { makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import axios from "axios";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import {
	openLoader,
	closeLoader,
} from "../../../redux/actions/loader/loaderActions";
import { closeModal } from "../../../redux/actions/modal/modalActions";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
			{
				textAlign: "center",
				padding: "8.1px 14px",
			},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

function DisableBusiness({
	id,
	setBearer,
}: {
	id: number | undefined;
	setBearer: React.Dispatch<React.SetStateAction<boolean>>;
}) {
	const classes = useStyles();

	const dispatch = useDispatch();

	const validate = Yup.object({
		action: Yup.string().required("Required"),
		reason: Yup.string().required("Required"),
		otp: Yup.string().required("Required"),
	});

	const action = [
		{
			name: "enable",
		},
		{
			name: "disable",
		},
	];

	const INITIAL_VALUES = {
		action: "",
		reason: "",
		otp: "",
	};

	return (
		<div className={styles.generalFourReuse}>
			<h3 className={styles.generalh3}>Modify Business Status</h3>
			<Divider />

			<div className={styles.selectinput}>
				<Formik
					initialValues={INITIAL_VALUES}
					validationSchema={validate}
					onSubmit={(values) => {
						dispatch(openLoader());

						axios
							.post(`v1/business/${id}/status/modify`, {
								action: values.action,
								reason: values.reason,
								otp: values.otp,
							})
							.then((res: any) => {
								setBearer(true);
								dispatch(closeLoader());

								dispatch(
									openToastAndSetContent({
										toastContent: res?.data?.message,
										toastType: "success",
									})
								);
								dispatch(closeModal());
							})
							.catch((err) => {
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent:
											err.response?.data?.message ||
											err?.data?.message ||
											err?.message ||
											err,
										toastType: "error",
									})
								);
							});
					}}
				>
					{(props) => (
						<Form>
							<InputLabel>
								<span className={styles.span}>ACTIONS</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="action">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="action"
								size="small"
								options={action}
								className={classes.select}
								defaultValue={action && action[0]}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>REASON</span>
							</InputLabel>
							<Field
								as={TextareaAutosize}
								helperText={
									<ErrorMessage name="reason">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								minRows={3}
								name="reason"
								variant="outlined"
								margin="normal"
								type="text"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
									marginBottom: "22px",
									padding: "10px",
									width: "100%",
									fontFamily: "Avenir",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>OTP</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="otp">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="otp"
								InputLabelProps={{
									style: { fontSize: "0.8em" },
								}}
								label="Get OTP from Google Authenticator App"
								variant="outlined"
								margin="normal"
								type="text"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
								}}
							/>

							<InputLabel>
								<div style={{ display: "flex", alignItems: "center" }}>
									<InfoRoundedIcon />
									<p className={styles.info}>
										If you have not set up your 2FA, kindly{" "}
										<a
											style={{ color: "blue" }}
											href={`/account`}
											target="_blank"
										>
											click here
										</a>
									</p>
								</div>
							</InputLabel>

							<button
								style={{
									backgroundColor: "#27AE60",
									fontFamily: "Avenir",
									fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "16px",
									lineHeight: "19px",
									textAlign: "center",
									border: "none",
									outline: "none",
									width: "100%",
									color: "#FFFFFF",
									padding: "13.39px 0",
									borderRadius: "20px",
									marginTop: "30px",
									cursor: "pointer",
								}}
								type="submit"
							>
								Submit
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default DisableBusiness;
